<h1 mat-dialog-title [attr.data-cy]="'devdevd_h1_1_4_'">{{ data?.title }}</h1>
<div mat-dialog-content>
    <p *ngIf="data?.text">{{ data.text }}</p>
    <p *ngIf="trustedHtml" [innerHTML]="trustedHtml"></p>

    <ng-container *ngFor="let v of data?.values; let i = index">
        <mat-form-field
            *ngIf="v.type !== 'date' && v.type !== 'textarea' && v.type !== 'toggle'"
            style="width: 100%"
            [attr.data-cy]="'devdevd_mat-form-field_1_8_' + i"
        >
            <mat-label [attr.data-cy]="'devdevd_mat-label_1_9_' + i">{{ v?.label ? v.label : "Eingabe" }}</mat-label>
            <input
                #valueInput="matInput"
                [attr.inputmode]="v?.inputmode"
                [formControl]="valueCtrls[i]"
                [type]="v?.type"
                cdkFocusInitial
                matInput
                [attr.data-cy]="'devdevd_input_1_1_' + i"
            />
            <mat-icon *ngIf="v?.suffixIcon" matSuffix [attr.data-cy]="'devdevd_mat-icon_1_2_' + i">{{
                v.suffixIcon
            }}</mat-icon>
            <button
                (click)="toggleShowHidePassword(i)"
                *ngIf="v?.showHidePassword"
                mat-icon-button
                matSuffix
                [attr.data-cy]="'devdevd_button_1_0_' + i"
            >
                <mat-icon [attr.data-cy]="'devdevd_mat-icon_2_2_' + i"
                    >{{ v?.type === "password" ? "visibility" : "visibility_off" }}
                </mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field *ngIf="v.type === 'date'" [attr.data-cy]="'devdevd_mat-form-field_2_8_' + i">
            <mat-label [attr.data-cy]="'devdevd_mat-label_2_9_'">{{ v?.label ? v.label : "Eingabe" }}</mat-label>
            <input
                matInput
                [matDatepicker]="picker"
                [formControl]="valueCtrls[i]"
                [readonly]="true"
                [attr.data-cy]="'devdevd_input_2_1_'"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field
            *ngIf="v.type === 'textarea'"
            style="width: 100%"
            [attr.data-cy]="'devdevd_mat-form-field_3_8_'"
        >
            <mat-label [attr.data-cy]="'devdevd_mat-label_3_9_'">{{ v?.label ? v.label : "Eingabe" }}</mat-label>
            <textarea [formControl]="valueCtrls[i]" matInput [rows]="v.rows"></textarea>
        </mat-form-field>
        <mat-slide-toggle
            *ngIf="v.type === 'toggle'"
            [formControl]="valueCtrls[i]"
            [attr.data-cy]="'devdevd_mat-slide-toggle_1_5_'"
            >{{ v?.label ? v.label : "Eingabe" }}
        </mat-slide-toggle>
    </ng-container>
</div>
<div mat-dialog-actions class="actions-corners">
    <button (click)="close()" mat-button [attr.data-cy]="'devdevd_button_2_0_'">Abbrechen</button>
    <div class="actions-corners__confirm">
        <button
            (click)="save()"
            (keyup.enter)="save()"
            [color]="data?.buttonColor"
            mat-flat-button
            [attr.data-cy]="'devdevd_button_3_0_'"
        >
            {{ data?.okButton }}
        </button>
    </div>
</div>
